import styled from 'styled-components';

export const Bar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`;

/**
 * Ramka zadania „zrób zwrot" — bursztyn, nie czerwień. Czerwień w tym widoku znaczy
 * „coś się wydarzyło", a tu chodzi o coś, co dopiero trzeba zrobić.
 */
export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border: 1px solid #fde68a;
  border-left: 3px solid #d97706;
  border-radius: 12px;
  background: #fffbeb;
`;

export const AlertHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    flex-shrink: 0;
    color: #b45309;
  }
`;

export const AlertTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #78350f;
`;

export const AlertCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: rgba(217, 119, 6, 0.16);
  font-size: 11px;
  font-weight: 600;
  color: #b45309;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-left: 3px solid #dc2626;
  border-radius: 12px;
  background: #fef2f2;

  svg {
    flex-shrink: 0;
    color: #dc2626;
  }
`;

export const Message = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #7f1d1d;

  strong {
    font-weight: 600;
  }
`;

export const Hint = styled.span`
  display: block;
  font-size: 12px;
  color: #b91c1c;
  opacity: 0.85;
`;

export const ViewButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: #dc2626;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  white-space: nowrap;

  &:hover {
    opacity: 0.75;
  }
`;

/** Ten sam link „Zobacz", ale w bursztynie ramki zadania. */
export const DismissButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 8px;
  background: none;
  color: #b91c1c;
  cursor: pointer;

  &:hover {
    background: rgba(220, 38, 38, 0.1);
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

/**
 * Przełącznik listy zadań — tekst, nie krzyżyk. „X" przy zadaniu do zrobienia
 * czyta się jak „załatwione", a tu chodzi tylko o schowanie wierszy.
 */
/** „Pokaż listę" na ostrzeżeniu — pełny guzik, nie link: to jedyne wyjście do zadania,
    a podkreślony tekst obok licznika ginął w bursztynowym tle. */
export const AlertActionButton = styled.button`
  margin-left: auto;
  padding: 4px 12px;
  border: none;
  border-radius: 999px;
  background: #b45309;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: #92400e;
  }
`;
